const PROJECT_ROWS = [
  {
    project: 'Roofing tear-off (shingles)',
    size: '5YD or 10YD',
    why: 'Can hold up to about ~20+/- squares',
  },
  {
    project: 'Bathroom remodel',
    size: '5YD–10YD',
    why: 'Perfect volume for demo debris, tile, drywall, fixtures',
  },
  {
    project: 'Garage cleanout',
    size: '10YD',
    why: 'Handles furniture, boxes, and general household items',
  },
  {
    project: 'Kitchen remodel',
    size: '10YD',
    why: 'More volume for cabinets, flooring, appliances (via junk removal)',
  },
  {
    project: 'Full room renovation',
    size: '10YD',
    why: 'Best for drywall, lumber, flooring across multiple rooms. May need multiple',
  },
  {
    project: 'Small move / declutter',
    size: '5YD',
    why: '~2 truck loads worth — ideal for a quick clean sweep',
  },
  {
    project: 'Home cleanout',
    size: '10YD',
    why: '~4 truck loads — handles furniture, toys, clothes and clutter. May need multiple dumpsters',
  },
  {
    project: 'Estate cleanout',
    size: '10YD',
    why: 'Volume and flexibility for whole-house clearing — probably will need multiple dumpsters',
  },
  {
    project: 'Concrete/asphalt removal',
    size: '5YD',
    why: 'Heavy debris — fill only ¾ full',
  },
  {
    project: 'Light construction debris',
    size: '10YD',
    why: 'Wood, drywall, metal — fits the job site volume',
  },
  {
    project: 'Yard waste / landscaping',
    size: 'Call us',
    why: 'Yard waste restrictions vary — contact us first',
  },
];

export const WhichSizeSection = () => {
  return (
    <section id="which-size-section" className="py-16 bg-white scroll-mt-4">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-6 italic text-center">
            Which Size Is Right for My Project?
          </h2>
          <p className="text-[#333333] text-center max-w-3xl mx-auto mb-10 leading-relaxed">
            Use this table as a quick guide. When in doubt, the 10YD dumpster is
            usually the best value and can often fit in the same spaces as the
            5YD. We can also deliver or swap out multiple bins at a discount — be
            sure to ask about these options!
          </p>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto rounded-lg border border-gray-200">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-[#333333] text-white">
                  <th className="py-3 px-4 font-semibold">Project Type</th>
                  <th className="py-3 px-4 font-semibold">Best Size</th>
                  <th className="py-3 px-4 font-semibold">Why</th>
                </tr>
              </thead>
              <tbody>
                {PROJECT_ROWS.map((row, idx) => (
                  <tr
                    key={row.project}
                    className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <td className="py-3 px-4 font-medium text-[#333333]">
                      {row.project}
                    </td>
                    <td className="py-3 px-4 font-bold text-[#E31837] whitespace-nowrap">
                      {row.size}
                    </td>
                    <td className="py-3 px-4 text-gray-600">{row.why}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {PROJECT_ROWS.map((row) => (
              <div
                key={row.project}
                className="border border-gray-200 rounded-lg p-4"
              >
                <p className="font-medium text-[#333333] mb-1">
                  {row.project}
                </p>
                <p className="font-bold text-[#E31837] text-sm mb-1">
                  {row.size}
                </p>
                <p className="text-gray-600 text-sm">{row.why}</p>
              </div>
            ))}
          </div>

          <p className="text-[#333333] text-center mt-8">
            Still not sure? Call or text us at{' '}
            <a
              href="tel:9529312577"
              className="text-[#E31837] font-semibold hover:underline"
            >
              952-931-2577
            </a>{' '}
            and describe your project in one sentence. We&apos;ll tell you
            exactly which bin to order.
          </p>
        </div>
      </div>
    </section>
  );
};
